import { render, staticRenderFns } from "./PurchaseNew.vue?vue&type=template&id=400f9088&"
import script from "./PurchaseNew.vue?vue&type=script&lang=js&"
export * from "./PurchaseNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports